import cookie from 'js-cookie'
import PRODUCT from 'src/api/dev/product'
import { add, del, copy } from 'src/api/dev/app'
import * as T from './types'
import { sendUser } from '../../../utils/tracker'

export default {
    [T.GET_PRODUCT_LIST]({ commit }) {
        return PRODUCT.list().then(res => {
            commit(T.SET_PRODUCT_LIST, res.items)
            sendUser({
                tenant_code: '',
                user_account: cookie.get('paas_name') // 数据收集上传账号信息
            })
            return res.items
        })
    },

    [T.ADD_PRODUCT_ITEM](store, item) {
        return PRODUCT.add(item)
    },

    [T.DELETE_PRODUCT_ITEM]({ commit }, id) {
        return PRODUCT.delete(id).then(res => {
            commit(T.DELETE_PRODUCT_ITEM, id)
            return res
        })
    },

    [T.UPDATE_PRODUCT_ITEM]({ commit }, item) {
        return PRODUCT.update(item).then(res => {
            commit(T.UPDATE_PRODUCT_ITEM, item)
            return res
        })
    },

    [T.GET_PRODUCT_ITEM]({ commit }, id) {
        return PRODUCT.detail(id).then(res => {
            commit(T.SET_PRODUCT_ITEM, res)
            return res
        })
    },

    [T.ADD_APP_ITEM](store, item) {
        return add(item)
    },

    [T.COPY_APP_ITEM](store, item) {
        return copy(item)
    },

    [T.DELETE_APP_ITEM](store, id) {
        return del(id)
    },

    [T.GET_PRODUCT_CRED_LIST]({ commit }, productId) {
        return PRODUCT.credList({ productId, pageSize: 100 }).then(res => {
            commit(T.SET_PRODUCT_CRED_LIST, res.items)
            return res
        })
    },

    [T.ADD_PRODUCT_CRED_ITEM](store, item) {
        return PRODUCT.addCred(item)
    },

    [T.UPDATE_PRODUCT_CRED_ITEM]({ commit }, item) {
        return PRODUCT.updateCred(item).then(res => {
            commit(T.UPDATE_PRODUCT_CRED_ITEM, item)
            return res
        })
    },

    [T.DELETE_PRODUCT_CRED_ITEM]({ commit }, id) {
        return PRODUCT.deleteCred(id).then(res => {
            commit(T.DELETE_PRODUCT_CRED_ITEM, id)
            return res
        })
    }
}
